const Vue = require('vue')
import apihelper from './apihelper'
import config from '@/util/config'

export default {
    getall() {
        return apihelper.get("/menu/getall");
    }
}